import { useSelector } from 'react-redux';
import { userDataSelector } from 'ducks/user/selectors';

export function useCompanyId() {
  const { companyId } = useSelector(userDataSelector);
  return companyId;
}

export function useCompanyAndUserId() {
  const { companyId, id } = useSelector(userDataSelector);
  return { companyId, userId: id };
}

export function useCompanyName() {
  const { companyId, companies } = useSelector(userDataSelector);
  return (
    companies?.find((company) => company.id === companyId)?.name ??
    companies?.[0]?.name
  );
}
